import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        filter: '<',
        selectedItems: '='
    },
    template: `
        <div ng-if="vm.error" class="alert alert-danger">
            {{ vm.error }}
        </div>
         <div class="form">
            <div class="row inline">
                <label class="label">{{ 'reports.Bulk actions' | translate }}</label>
                <div class="items">
                    <select class="form-control small" ng-model="vm.action">
                        <option value="markComplete">{{ 'reports.Mark as completed (passed outside the system)' | translate }}</option>
                    </select>
                    <button class="btn bordered02" ng-click="vm.handleBulkAction()">{{ 'general.Ok' | translate }}</button>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, toastr, ModalService, COURSE_TRAINING_TYPE_ENUM) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.ModalService = ModalService;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
    }

    $onInit () {
        this.action = 'markComplete';
        this.selectedItems = [];
    }

    handleBulkAction () {
        if (this.selectedItems.length === 0) {
            this.toastr.error(this.$translate.instant('general.Please select at least one occurrence'));
        }
        else if (this.action === 'markComplete') {
            this.handleMarkComplete();
        }
    }

    handleMarkComplete () {
        if (this.error) {
            return;
        }

        const { selectedItems } = this;

        this.ModalService.open({
            template: '<modals-report-courseprogress-complete class="wrapper" uib-modal-instance="vm.$uibModalInstance" selected-items="vm.selectedItems"/>',
            controller ($uibModalInstance) {
                this.selectedItems = selectedItems;
                this.$uibModalInstance = $uibModalInstance;
            },
            size: 'xlarge'
        }).then(() => {
            this.toastr.success(this.$translate.instant('reports.Courses have been marked as successfully completed for the selected employees'));
            this.list.fetch(this.filter);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/courseprogress/bulk/index.js